import { HttpLink } from '@apollo/client'

import { getBaseHttpHeaders } from '../../httpHeaders'

type TCreateHttpLinkOptions = {
  authToken: string
  locale: string
  backendUrl: string
}

/**
 * creates an Apollo GQL client HTTP link
 * filling it with required header (user token, selected language)
 * ! this is a terminating link and it should be placed at the end of the link array
 * https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link
 */
export const createHttpLink = ({ authToken, locale, backendUrl }: TCreateHttpLinkOptions) => {
  return new HttpLink({
    uri: `${backendUrl}/graphql`,
    headers: getBaseHttpHeaders({ locale, authToken }),
  })
}
